import type { ClimbVideo } from '../types/climb-video';

interface LikeUser {
  id: number;
  username: string;
  slug: string;
  avatar_small_url?: string;
}

/** Optimistic local like toggle for the current user (reconciled with the server response). */
export function toggleLikeLocal(video: ClimbVideo, user: LikeUser): ClimbVideo {
  const uid = String(user.id);
  const liked = video.likers.some(l => l.id === uid);
  const likers = liked
    ? video.likers.filter(l => l.id !== uid)
    : [
        { id: uid, username: user.username, slug: user.slug, avatar_small_url: user.avatar_small_url ?? null, liked_at: new Date().toISOString() },
        ...video.likers,
      ];
  return { ...video, likers };
}
